

import React, { useContext, useState } from 'react';
import { Menubar } from 'primereact/menubar';
import { NavLink, Outlet } from 'react-router-dom';
import LayoutContext from '../Context/LayoutContext';
import AppContext from '../Context/AppContext';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import Cookies from 'js-cookie';
import { Button } from 'primereact/button';

const Layout = () => {
    const [navbar, setNavbar] = useState(null);

    const { user, setUser } = useContext(AppContext)

    const logout = () => {
        confirmDialog({
            group: 'logout',
            message: <p>Are you sure you want to logout?</p>,
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            acceptLabel: 'Continue',
            rejectLabel: 'Cancel',
            accept: () => {
                Cookies.remove('token', { path: process.env.REACT_APP_SUBFOLDER })
                setUser(null)
            }
        });
    }

    return (
        <LayoutContext.Provider value={{ navbar, setNavbar }}>
            <div className='flex flex-column relative surface-ground h-full w-full'>
                <nav className='topbar flex justify-content-center'>
                    <div className='flex gap-3 px-3 md:px-4 py-2 container text-xl align-items-center w-full'>
                        <span className='mr-3 hidden md:block'>Security System</span>

                        <NavLink className="nav-link text-base hidden md:block" to="/codes">Codes</NavLink>
                        <NavLink className="nav-link text-base hidden md:block" to="/reports">Reports</NavLink>
                        {user.permissions.admin && <NavLink className="nav-link text-base hidden md:block" to="/users">Users</NavLink> }
                        {user.permissions.admin && <NavLink className="nav-link text-base hidden md:block" to="/contacts">Contacts</NavLink> }
                        {user.permissions.admin && <NavLink className="nav-link text-base mr-auto hidden md:block" to="/logs">Logs</NavLink> }

                        {navbar}
                        <Button onClick={logout} className='hidden md:block' icon="pi pi-sign-out" severity="secondary"/>
                    </div>
                </nav>

                <Outlet />

                <nav className='bottombar flex justify-content-center block md:hidden'>
                    <div className='flex gap-3 px-4 py-3 container text-xl align-items-center w-full justify-content-evenly'>
                        <NavLink className="nav-link text-base" to="/codes"><i className="pi pi-shield text-4xl"></i></NavLink>
                        <NavLink className="nav-link text-base" to="/reports"><i className="pi pi-folder-open text-4xl"></i></NavLink>
                        {user.permissions.admin && <NavLink className="nav-link text-base" to="/users"><i className="pi pi-users text-4xl"></i></NavLink> }
                        {user.permissions.admin && <NavLink className="nav-link text-base" to="/contacts"><i className="pi pi-address-book text-4xl"></i></NavLink> }
                        {user.permissions.admin && <NavLink className="nav-link text-base" to="/logs"><i className="pi pi-folder text-4xl"></i></NavLink> }
                        <button onClick={logout} className="text-base bg-transparent border-none icon-menu-button p-0 m-0" style={{width: "32px"}}><i className="pi pi-sign-out text-4xl"></i></button>
                    </div>
                </nav>
            </div>
            <ConfirmDialog group="logout" draggable={false}/>
        </LayoutContext.Provider>
    );
};

/*
<Menubar pt={{ root: { style: {backgroundColor: "#2b3035", border: "none", borderRadius: "0px"}} }} model={items} />
*/

export default Layout;